import React from 'react';

import StockIntegrationsTable from '../components/stock-integration/table'
import StockIntegrationProfile from '../components/stock-integration/profile';

class StockIntegrationsPage extends React.Component {

    render() {

        if (!this.props.match.params.supplierId) {
            return <StockIntegrationsTable />
        }

        return (
            <StockIntegrationProfile supplierId={this.props.match.params.supplierId}/>
        )
    }

}

export default StockIntegrationsPage;


// WEBPACK FOOTER //
// ./src/containers/stock-integrations-page.js